function Menu() {
  return (
    <div className="d-flex flex-column justify-content-center top-menu">
      <div className="row">
        <div className="center-block title-box">
          <div className="text-center">
            <span className="fw-bold small title-text text-uppercase">
              <a className="plain-link" href="https://www.sigir-ap.org/sigir-ap-2024/">
                SIGIR-AP 2024
              </a>
            </span>
          </div>
          <div className="text-center">
            <span className="fs-1 title-text text-uppercase">
              Paradigm Shifts in Team Recommendation:
            </span>
          </div>
          <div className="text-center">
            <span className="fw-bold title-text text-uppercase">
              From Historical Subgraph Optimization to Emerging Graph Neural Network
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
